<template>
<div>    
    <base-header v-once pageName="영업활동계획서" :popup="true"></base-header>
    
    <section id="wrap">
        <h2 class="bsnsAcpln-mem"><em :class="pstnChk()"></em><span>{{userName}}</span><i>{{userId}}</i></h2>
        <h3 class="bsnsAcpln-tit">{{planYr}}년 {{planMn}}월 영업활동계획</h3>
        <div class="bsnsAcpln-view">
            <div>
                <template v-if="pstnTyp === 'COG02'">
                     <h6 >지구 실적 목표</h6>
                   <span><em>{{headAmtSum | numFormat}}</em>만원</span>
                </template>
               
                <h6 v-if="pstnTyp != 'COG01'">개인 실적 목표</h6>
                <h6 v-if="pstnTyp === 'COG01'">지국 실적 목표</h6>
                <span><em>{{amtSum | numFormat}}
                    <template v-if="pstnTyp === 'COG01' && amtSum != orcpAmtSum">
                            ({{orcpAmtSum | numFormat}})
                    </template></em>만원</span>
                <ul>
                    <li>
                        <strong>전집</strong>
                        <span><em>{{cmclGoalAmt | numFormat}}
                            <template v-if="pstnTyp === 'COG01' && cmclGoalAmt != orcpCmclGoalAmt">
                            ({{orcpCmclGoalAmt | numFormat}})
                          </template>
                            </em>만원
                        </span>
                    </li>
                    <li>
                        <strong>멤버십</strong>
                        <span><em>{{mmbsGoalAmt | numFormat}}
                            <template v-if="pstnTyp === 'COG01' && mmbsGoalAmt != orcpMmbsGoalAmt">
                            ({{orcpMmbsGoalAmt | numFormat}})
                          </template>
                            </em>만원</span>
                    </li>
                    <li>
                        <strong>프리패스</strong>
                        <span><em>{{frpsGoalAmt | numFormat}}
                            <template v-if="pstnTyp === 'COG01' && frpsGoalAmt != orcpFrpsGoalAmt">
                            ({{orcpFrpsGoalAmt | numFormat}})
                          </template>
                            </em>만원</span>
                    </li>
                    <li>
                        <strong>기타(잡지등)</strong>
                        <span><em>{{etcGoalAmt | numFormat}}
                          <template v-if="pstnTyp === 'COG01' && etcGoalAmt != orcpEtcGoalAmt">
                            ({{orcpEtcGoalAmt | numFormat}})
                          </template>
                            </em>만원</span>
                    </li>
                </ul>
            </div>
            <div>
                <h6>활동 목표</h6>
                <ul class="flex">
                    <li>
                        <strong>소스</strong>
                        <span><em>{{srcGoalCscnt | numFormat}}</em>건</span>
                    </li>
                    <li>
                        <strong>진단서비스</strong>
                        <span><em>{{dgnssrvcGoalCscnt | numFormat}}</em>건</span>
                    </li>
                    <!-- <li>
                        <strong>리크루팅</strong>
                        <span><em>{{rcrtGoalCscnt | numFormat}}</em>건</span>
                    </li> -->
                </ul>
            </div>
            <div>
                <h6>상담 목표</h6>
                <ul class="flex">
                    <li>
                        <strong>기존상담</strong>
                        <span><em>{{exsnConsCscnt | numFormat}}</em>명</span>
                    </li>
                    <li>
                        <strong>신규상담</strong>
                        <span><em>{{newConsCscnt | numFormat}}</em>명</span>
                    </li>
                </ul>
            </div>
        </div>
        <dl class="bsnsAcpln-view">
            <dt>구간 마감</dt>
            <dd>
                <p>단위(만원)</p>
                <table>
                    <thead>
                        <tr>
                            <th>마감</th>
                            <th>목표</th>
                            <th>전집</th>
                            <th>멤버십</th>
                            <th>프리패스</th>
                            <th>기타</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1영업일</td>
                            <td>{{Math.floor(beginPeriod*100)+'%'}}</td>
                            <td>{{Math.floor(cmclGoalAmt*beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor(mmbsGoalAmt*beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor(frpsGoalAmt*beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor(etcGoalAmt*beginPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>1구간</td>
                            <td>{{Math.floor(firstPeriod*100)+'%'}}</td>
                            <td>{{Math.floor(cmclGoalAmt*firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor(mmbsGoalAmt*firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor(frpsGoalAmt*firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor(etcGoalAmt*firstPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>2구간</td>
                            <td>{{Math.floor(secondPeriod*100)+'%'}}</td>
                            <td>{{Math.floor(cmclGoalAmt*secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor(mmbsGoalAmt*secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor(frpsGoalAmt*secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor(etcGoalAmt*secondPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>3구간</td>
                            <td>{{Math.floor(thridPeriod*100)+'%'}}</td>
                            <td>{{Math.floor(cmclGoalAmt*thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor(mmbsGoalAmt*thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor(frpsGoalAmt*thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor(etcGoalAmt*thridPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>월마감</td>
                            <td>{{Math.floor(monthEnd*100)+'%'}}</td>
                            <td>{{Math.floor(cmclGoalAmt*monthEnd) | numFormat}}</td>
                            <td>{{Math.floor(mmbsGoalAmt*monthEnd) | numFormat}}</td>
                            <td>{{Math.floor(frpsGoalAmt*monthEnd) | numFormat}}</td>
                            <td>{{Math.floor(etcGoalAmt*monthEnd) | numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
            </dd>
            <template v-if="pstnTyp != 'COG01'">
                <dt>기타 보고사항</dt>
                <dd class="memo">{{memo}}</dd>
            </template>
        </dl>
    </section>
    <div class="btnWrap">
        
        <button type="button" class="red" @click="regBsnPln" v-if="planYr === endYr && planMn === endMn && pstnTyp != 'COG01'">수정</button>
      
    </div>
</div>
</template>

<script>

export default {
  data() {
		return{
			sqno : this.$route.query.sqno,
            userName : '',
            userId : '',
            pstn : '',
            planYr : '',
            planMn : '',
			txtSize : 0,
			saveTxt : '등록',
            amtSum : '',
            orcpAmtSum : '',
            headAmtSum : '',
            cmclGoalAmt : '',
            mmbsGoalAmt : '',
            frpsGoalAmt : '',
            etcGoalAmt : '',
            
            orcpCmclGoalAmt : '',
            orcpMmbsGoalAmt : '',
            orcpFrpsGoalAmt : '',
            orcpEtcGoalAmt : '',

            srcGoalCscnt : '',
            dgnssrvcGoalCscnt : '',
            rcrtGoalCscnt : '',
            exsnConsCscnt : '',
            newConsCscnt : '',
            memo : '',
            pstnTyp : this.$store.getters.orgnzPstn,


            period : [],
            beginPeriod : 0,
            firstPeriod : 0,
            secondPeriod : 0,
            thridPeriod : 0,
            monthEnd : 0,
            endDt : '',
            endDt2 : '',
            endYr : '',
            endMn : '',
            endDy : ''

		};
  },

methods: {
    bsnPlnList: function(){
        this.$router.push('/mypage/bsnPlnList'); 
    },  
    regBsnPln: function(){
        
        if(this.endDt2 < this.endYr+this.endMn+this.endDy || this.endDt > this.endYr+this.endMn+this.endDy) {
            alert("수정 가능 기간이 아닙니다.");
            return false;
        }
        this.$router.push('/mypage/bsnPlnReg?sqno='+this.sqno+'&planYr='+this.planYr+'&planMn='+this.planMn); 
    },
    pstnChk : function(){
        var pstnChkFlag;
        if(this.$store.getters.orgnzPstn == 'COG01') {
            pstnChkFlag = ''; //지국장
        }else if (this.$store.getters.orgnzPstn == 'COG02'){
            pstnChkFlag = 'epLv1'; //지구장
        }else if (this.$store.getters.orgnzPstn == 'COGA2'){
            pstnChkFlag = 'epLvA1'; //마스터
        }else if (this.$store.getters.orgnzPstn == 'COG03'){
            pstnChkFlag = 'epLv2'; //프로
        }else if (this.$store.getters.orgnzPstn == 'COG04'){
            pstnChkFlag = 'epLv3'; //일반
        }else if (this.$store.getters.orgnzPstn == 'COG05'){
            pstnChkFlag = 'epLv4'; //파트너
        }
        return pstnChkFlag;
    }
},

created : function(){

    var firstDayOfPreMon = new Date();

    var yearOfPreMon = firstDayOfPreMon.getFullYear()+'';
    var monthOfPreMon = ((firstDayOfPreMon.getMonth() + 1) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() + 1);
    var dayOfPreMon = ("00"+(firstDayOfPreMon.getDate())).slice(-2); // 일 (2자리)

    this.endYr = yearOfPreMon;
    this.endMn = monthOfPreMon;
    this.endDy = dayOfPreMon;

    if(this.sqno){
      
        var that = this;
        var parameters = {
            sqno : this.sqno
        };
        this.$api.mypage
        .bsnPlnInfo(parameters)
        .then(function(data) {
            
            if(data){
                that.sqno = data.sqno;
                that.amtSum = data.amtSum;
                that.headAmtSum = data.headAmtSum;
                that.orcpAmtSum = data.orcpAmtSum;
                that.userName = data.userName;
                that.userId = data.userId;
                that.pstn = data.pstn;
                that.planYr = data.planYr;
                that.planMn = data.planMn;
                that.cmclGoalAmt = data.cmclGoalAmt;
                that.orcpCmclGoalAmt = data.orcpCmclGoalAmt;
                that.orcpMmbsGoalAmt = data.orcpMmbsGoalAmt;
                that.orcpFrpsGoalAmt = data.orcpFrpsGoalAmt;
                that.orcpEtcGoalAmt = data.orcpEtcGoalAmt;
                that.mmbsGoalAmt = data.mmbsGoalAmt;
                that.frpsGoalAmt = data.frpsGoalAmt;
                that.etcGoalAmt = data.etcGoalAmt;
                that.srcGoalCscnt = data.srcGoalCscnt;
                that.dgnssrvcGoalCscnt = data.dgnssrvcGoalCscnt;
                that.rcrtGoalCscnt = data.rcrtGoalCscnt;
                that.exsnConsCscnt = data.exsnConsCscnt;
                that.newConsCscnt = data.newConsCscnt;
                that.memo = data.memo;
                that.period = data.period;
                that.endDt = data.endDt;
                that.endDt2 = data.endDt2;

                that.beginPeriod = data.period[0].cdVl1;
                that.firstPeriod = data.period[1].cdVl1;
                that.secondPeriod = data.period[2].cdVl1;
                that.thridPeriod = data.period[3].cdVl1;
                that.monthEnd = data.period[4].cdVl1;
                
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    }
},
    filters:{
        numFormat:function(num){
            
            if(num==0) return 0;

            var n = num+'';
            var reg = /(^[+-]?\d+)(\d{3})/;

            while (reg.test(n))
                n = n.replace(reg,'$1'+','+'$2');
            
            return n;
        }
    }
};
</script>